import { createFileRoute } from '@tanstack/react-router';
import { Outlet, redirect } from '@tanstack/react-router';
import Header from '@/shared/components/header/Header';
import { MainNavigation } from '@/shared/components/navigation/MainNavigation';
import { usePageTitle } from '@/shared/hooks/usePageTitle';
import { useAuth } from '../stores/auth';
import { useAcl } from '@/shared/hooks';
import { AclError, NoPermissions } from '@/shared/components/error/AclError';
import { LoadingScreen } from '@/shared/components/loader/LoadingScreen';
import { getMyrclLoginUrl } from '@/app/utils/auth';

export const Route = createFileRoute('/_auth')({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      const myrclLoginUrl = getMyrclLoginUrl();
      if (myrclLoginUrl) {
        throw redirect({ href: myrclLoginUrl });
      }
      console.error('VITE_MYRCL_LOGIN_URL is not configured');
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  const auth = useAuth();
  const pageTitle = usePageTitle();
  const { isLoading, error, navigationModules, refetch } = useAcl();

  // Show loading state while ACL is being fetched
  if (isLoading) {
    return <LoadingScreen message="Verifying access.." />;
  }

  // Show error state if ACL failed to load
  if (error) {
    return <AclError error={error} onRetry={refetch} />;
  }

  // Show no permissions state if user has no accessible modules
  if (!navigationModules || navigationModules.length === 0) {
    return <NoPermissions />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header
        pageTitle={pageTitle}
        navLinks={[
          { label: 'FAQ', to: '/faq' },
          { label: 'Technical Support', to: '/support' },
          { label: 'Back to Crew Journey', to: '/crew-journey' },
        ]}
        userName={auth.decodedToken?.EmailAddress || 'User'}
        onSignOut={auth.logout}
      />
      <MainNavigation />

      <main className="flex-1 flex flex-col">
        <Outlet />
      </main>
    </div>
  );
}
